<template>
  <div class="page flex-col">
    <el-dialog :visible.sync="dialogVisible" @close="closeDialog" title="用户反馈" style="width: 1500px;">
      <dialog-content @close="dialogVisible=false"></dialog-content>
    </el-dialog>
    <div class="box_11 flex-row">
      <div class="section_11 flex-col">
        <div class="box_3 flex-col">
          <div class="text-wrapper_27 flex-row"><span class="text_1">面试表现</span></div>
          <div class="group_3 flex-row">
            <div class="text-wrapper_2 flex-row">
              <span class="text_2">95</span>
              <span class="text_3">分</span>
            </div>
            <div class="box_12 flex-col justify-between">
              <div class="block_1 flex-col"></div>
              <div class="block_2 flex-col"></div>
            </div>
            <div class="text-wrapper_28 flex-col">
              <span class="text_4">肢体动作</span>
              <span class="text_5">86</span>
              <span class="text_6">面部表情</span>
            </div>
            <div class="box_13 flex-col justify-between">
              <div class="block_3 flex-col"></div>
              <div class="block_4 flex-col"></div>
            </div>
            <div class="text-wrapper_29 flex-col">
              <span class="text_7">回答内容</span>
              <span class="text_8">96</span>
              <span class="text_9">面试语气</span>
            </div>
            <div class="box_14 flex-col justify-between">
              <div class="section_4 flex-col"></div>
              <div class="section_5 flex-col"></div>
            </div>
            <div class="text-wrapper_30 flex-col">
              <span class="text_10">仪容仪表</span>
              <span class="text_11">98</span>
              <span class="text_12">及时回应</span>
            </div>
          </div>
          <div class="text-wrapper_31 flex-row">
            <span class="text_13">面试总评</span>
            <span class="text_14">84</span>
            <span class="text_15">98</span>
            <span class="text_16">95</span>
          </div>
        </div>
        <span class="text_17">推荐学习网课</span>
        <div style="display:flex;flex-direction:column;width:510px;height:500px;overflow-y:auto;overflow-x:hidden;">
          <div class="box_5 flex-row" v-for="(item, index) in lessonCards" :key="index">
            <div class="image-text_10 flex-row justify-between">
              <img class="thumbnail_1" referrerpolicy="no-referrer"
                src="./assets/img/SketchPngf5aeebc2dc0da64c6d52c008e09256a38103a63cf38e68534cbb73636d1c4629.png" />
              <span class="text-group_1">{{ item.watch }}</span>
            </div>
            <div class="image-text_11 flex-row justify-between">
              <img class="thumbnail_2" referrerpolicy="no-referrer"
                src="./assets/img/SketchPng32444deacfa2e415879051b5f8fbaa7f5655e96541fcbfee0bb82db4121fe0b6.png" />
              <span class="text-group_2">{{ item.like }}</span>
            </div>
            <div class="image-text_12 flex-row">
              <img class="image_2" referrerpolicy="no-referrer" :src="item.img_url" />
              <div class="text-wrapper_32 flex-col" style="position:absolute;" v-if="item.tag != ''"><span
                  class="text_58">{{ item.tag }}</span></div>
              <div class="text-group_10 flex-col justify-between">
                <span class="text_18">
                  {{ item.title }}
                  <el-tag size="small" type="primary" v-if="item.read">已看</el-tag>
                  <el-tag size="small" type="danger" v-else>未看</el-tag>
                </span>
                <span class="text_19">{{ item.subtitle }}</span>
              </div>
            </div>
          </div>
          <div class="box_5 flex-row">
            <div class="image-text_10 flex-row justify-between">
              <img class="thumbnail_1" referrerpolicy="no-referrer"
                src="./assets/img/SketchPngf5aeebc2dc0da64c6d52c008e09256a38103a63cf38e68534cbb73636d1c4629.png" />
              <span class="text-group_1">1120</span>
            </div>
            <div class="image-text_11 flex-row justify-between">
              <img class="thumbnail_2" referrerpolicy="no-referrer"
                src="./assets/img/SketchPng32444deacfa2e415879051b5f8fbaa7f5655e96541fcbfee0bb82db4121fe0b6.png" />
              <span class="text-group_2">9820</span>
            </div>
            <div class="image-text_12 flex-row">
              <div class="image_1 flex-col">
                <div class="text-wrapper_32 flex-col"><span class="text_58">干货</span></div>
              </div>
              <div class="text-group_10 flex-col justify-between">
                <span class="text_18">【国庆大放价】徐涛职场面试常问问题，一站式通过面试</span>
                <span class="text_19">能拿高绩效的人都做对了什么？</span>
              </div>
              <div class="text-wrapper_7 flex-col"><span class="text_20">已看</span></div>
            </div>
          </div>
          <div class="box_6 flex-row">
            <div class="image-text_13 flex-row justify-between">
              <img class="thumbnail_3" referrerpolicy="no-referrer"
                src="./assets/img/SketchPngf5aeebc2dc0da64c6d52c008e09256a38103a63cf38e68534cbb73636d1c4629.png" />
              <span class="text-group_4">620</span>
            </div>
            <div class="image-text_14 flex-row justify-between">
              <img class="thumbnail_4" referrerpolicy="no-referrer"
                src="./assets/img/SketchPng32444deacfa2e415879051b5f8fbaa7f5655e96541fcbfee0bb82db4121fe0b6.png" />
              <span class="text-group_5">709</span>
            </div>
            <div class="image-text_15 flex-row">
              <div class="group_1 flex-col">
                <div class="text-wrapper_33 flex-col"><span class="text_59">干货</span></div>
              </div>
              <div class="text-group_11 flex-col justify-between">
                <span class="text_22">能拿高绩效的人都做对了什么？升职涨薪必看攻略！</span>
                <span class="text_23">徐涛职场面试常问问题，一站式通过面试</span>
              </div>
              <div class="text-wrapper_9 flex-col"><span class="text_24">未看</span></div>
            </div>
          </div>
          <div class="box_7 flex-row">
            <div class="image-text_16 flex-row justify-between">
              <img class="thumbnail_5" referrerpolicy="no-referrer"
                src="./assets/img/SketchPngf5aeebc2dc0da64c6d52c008e09256a38103a63cf38e68534cbb73636d1c4629.png" />
              <span class="text-group_7">620</span>
            </div>
            <div class="image-text_17 flex-row justify-between">
              <img class="thumbnail_6" referrerpolicy="no-referrer"
                src="./assets/img/SketchPng32444deacfa2e415879051b5f8fbaa7f5655e96541fcbfee0bb82db4121fe0b6.png" />
              <span class="text-group_8">709</span>
            </div>
            <div class="image-text_18 flex-row">
              <img class="image_2" referrerpolicy="no-referrer"
                src="./assets/img/2deddc9a5f2547e4b630bcc33586cfeb_mergeImage.png" />
              <div class="text-group_12 flex-col justify-between">
                <span class="text_25">二本生闯入大厂后裸辞？</span>
                <span class="text_26">二本生闯入大厂后裸辞？扮演工作是什么</span>
              </div>
              <div class="text-wrapper_10 flex-col"><span class="text_27">已看</span></div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="box_8 flex-col"></div> -->
      <div class="box_9 flex-col">
        <div class="box_15 flex-row justify-between">
          <span class="text_28">面试问题解析</span>
          <div class="group_2 flex-row" style="cursor: pointer;" @click="exportQuestion">
            <div class="image-wrapper_5 flex-col justify-between">
              <img class="thumbnail_11" referrerpolicy="no-referrer"
                src="./assets/img/SketchPngcccce5872beae687fd67b2b79f2cd0cc9e2a3fdbc705557baed714a91fc74fe8.png" />
              <img class="thumbnail_12" referrerpolicy="no-referrer"
                src="./assets/img/SketchPng58f0edd0c2a6d7510719f328ab4b67d63c6cca567ac19d3b9f07d1ec4199bce3.png" />
            </div>
            <span class="text_29">导出</span>
            <img class="thumbnail_13" referrerpolicy="no-referrer"
              src="./assets/img/SketchPng6925b6dc0cffd624381b5c92c82c25ae8ccf8fad3e6c745672cb5821b4ac4a72.png" />
          </div>
        </div>
        <div style="overflow-y: auto;height: 716px;">
          <div class="section_7 flex-col" v-for="(item, index) in questionCards" :key="index">
            <div class="text-wrapper_23 flex-col"
              :style="{ '--tag-color': tagColorIterable[index % tagColorIterable.length] }">
              <span class="text_54">题:{{ index + 1 }}</span>
            </div>
            <div class="text-wrapper_34 flex-row justify-between">
              <span class="text_30">问题：</span>
              <span class="text_31">{{ item.question }}</span>
            </div>
            <div class="text-wrapper_35 flex-row justify-between">
              <span class="text_32">答案:</span>
              <span class="text_33">{{ item.answer }}</span>
            </div>
            <div class="text-wrapper_36 flex-row justify-between">
              <span class="text_34">批阅:</span>
              <span class="text_35">{{ item.comment }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DialogContent from './components/lanhu_yonghufankui/index.vue'
export default {
  components: {
    DialogContent
  },
  data() {
    return {
      dialogVisible: true,
      tagColorIterable: ['red', 'orange', 'green', 'cyan', 'blue', 'purple'],
      lessonCards: [
        {
          img_url: require('./assets/img/2deddc9a5f2547e4b630bcc33586cfeb_mergeImage.png'),
          tag: '高赞',
          title: '【国庆大放价】徐涛职场面试常问问题，一站式通过面试',
          subtitle: '能拿高绩效的人都做对了什么？',
          read: true,
          watch: 0,
          like: 0
        },
        {
          img_url: require('./assets/img/2deddc9a5f2547e4b630bcc33586cfeb_mergeImage.png'),
          tag: '高赞',
          title: '【国庆大放价】徐涛职场面试常问问题，一站式通过面试',
          subtitle: '能拿高绩效的人都做对了什么？',
          read: true,
          watch: 0,
          like: 0
        }
      ],
      questionCards: [
        {
          question: '请做一段自我介绍',
          answer: '尊敬的面试官：您好！我叫肖伟。非常荣幸能够参加今天的面试。我毕业于上海交大，所学专业是数字媒体艺术。在大学期间，我不仅努力学习专业知识，还积极参加各种社团活动和实践项目，这极大地锻炼了我的团队协作能力和沟通能力。',
          comment: '缺少工作经历或实习经历部分'
        },
        {
          question: '请说一下你对前端岗位职责的理解',
          answer: '页面设计与开发：利用HTML、CSS和JavaScript等技术，将设计师提供的设计图转化为实际可在浏览器中运行的网页。确保页面布局合理、美观，并且在不同设备和浏览器上都能良好地显示。',
          comment: '回答的不够全面'
        },
        {
          question: '在上家公司主要负责哪一块儿的业务',
          answer: '与后端协作：与后端开发人员配合，通过接口获取数据并展示在页面上，同时将用户的操作数据传递给后端进行处理。',
          comment: '多了解浏览器的工作原理和兼容性问题，能够解决不同浏览器之间的显示差异'
        },
        {
          question: '上家公司离职原因是什么',
          answer: '在上家公司工作期间，我虽然积累了一定的经验，但随着时间的推移，我发现公司的业务发展方向与我的职业规划逐渐出现偏差，晋升空间也较为有限。',
          comment: '面试官察觉此应聘者不稳定'
        }
      ]
    };
  },
  methods: {
    exportQuestion(){
      console.log('export')
    },
    closeDialog(){
      console.log('dialog closed')
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />